import React from 'react'
import { withAnalytics, WithAnalyticsProps } from '#src/containers/Analytics'
import CuratedStatusBar from '#src/components/CuratedStatusBar'
import { DepartmentLeadFragment, DepartmentInfoQuery } from '#src/generated/graphql'

interface CurationStatusProps extends WithAnalyticsProps {
  lead?: DepartmentLeadFragment | null
  department: DepartmentInfoQuery['departmentBySlug'] | null
  backgroundImage: string
}

const CurationStatus: React.SFC<CurationStatusProps> = ({ lead, department }) => {
  if (!department) return null

  return (
    <CuratedStatusBar
      lead={lead}
      topLevelCategory={department ? department.topLevelCategory : null}
      departmentSlug={department.slug}
      isDepartmentInactive={!department.launched || !department.acceptingRequests}
    />
  )
}

export default withAnalytics(CurationStatus)
